import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=cd8878a2&"
import script from "./UploadInput.vue?vue&type=script&lang=js&"
export * from "./UploadInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8878a2')) {
      api.createRecord('cd8878a2', component.options)
    } else {
      api.reload('cd8878a2', component.options)
    }
    module.hot.accept("./UploadInput.vue?vue&type=template&id=cd8878a2&", function () {
      api.rerender('cd8878a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/ui/forms/UploadInput.vue"
export default component.exports